/* eslint-disable @typescript-eslint/no-namespace, no-redeclare, no-inner-declarations */

export enum ContainerAccess {
  ReadOnly = 'ro',
  ReadWrite = 'rw',
  Admin = 'admin',
}

export type RoleMatrix = Record<string, boolean>

export namespace ContainerAccess {
  const values = {
    [ContainerAccess.ReadOnly]: 1,
    [ContainerAccess.ReadWrite]: 2,
    [ContainerAccess.Admin]: 3,
  };

  export function valueOf(access: ContainerAccess): number {
    return values[access] || 0;
  }

  export function roleMatrix(maxAccess: number): RoleMatrix {
    return {
      [ContainerAccess.ReadOnly]: maxAccess >= values[ContainerAccess.ReadOnly],
      [ContainerAccess.ReadWrite]: maxAccess >= values[ContainerAccess.ReadWrite],
      [ContainerAccess.Admin]: maxAccess >= values[ContainerAccess.Admin],
    };
  }
}
